import * as React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import { GreenPlanet } from "../GreenPlanet";
const useStyles = makeStyles(({
  palette,
  breakpoints,
  typography
}) => ({
  icon: {
    [breakpoints.down("sm")]: {
      fontSize: typography.pxToRem(45),
      marginRight: typography.pxToRem(30)
    },
    color: palette.primary.main,
    fontSize: typography.pxToRem(50),
    marginRight: typography.pxToRem(35)
  },
  text: {
    fontSize: typography.pxToRem(19),
    lineHeight: 1.13,
    letterSpacing: 0.44,
    [breakpoints.down("sm")]: {
      fontSize: typography.pxToRem(16),
      letterSpacing: 0.37
    }
  },
  subtitle: {
    [breakpoints.down("sm")]: {
      fontSize: typography.pxToRem(10),
      letterSpacing: 0.37,
      whiteSpace: "normal"
    },
    fontSize: typography.pxToRem(12),
    lineHeight: 1.6,
    letterSpacing: 0.3,
    marginTop: typography.pxToRem(10),
    color: palette.text.optionSubtitle,
    maxWidth: typography.pxToRem(210),
    whiteSpace: "pre-line"
  },
  notAvailableText: {
    [breakpoints.down("sm")]: {
      fontSize: typography.pxToRem(12),
      letterSpacing: 0.37
    },
    fontSize: typography.pxToRem(14),
    lineHeight: 1.13,
    letterSpacing: 0.44,
    marginTop: typography.pxToRem(4)
  },
  container: {
    [breakpoints.down("sm")]: {
      marginBottom: typography.pxToRem(20),
      width: "inherit"
    },
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: typography.pxToRem(25),
    cursor: "pointer",
    width: typography.pxToRem(380),
    position: "relative"
  },
  notAvailable: {
    opacity: 0.3,
    cursor: "default"
  },
  greenPlanet: {
    [breakpoints.down("sm")]: {
      left: typography.pxToRem(75)
    },
    position: "absolute",
    top: typography.pxToRem(45),
    left: typography.pxToRem(85)
  },
  greenPlanetIcon: {
    [breakpoints.down("sm")]: {
      alignSelf: "flex-start",
      margin: `${typography.pxToRem(4)} 0`
    }
  }
}));

const OptionItem = ({
  action,
  onClick,
  getOptionIcon,
  unavailableOptionText,
  isOptionBestForPlanet,
  className
}) => {
  const {
    code,
    name,
    subtitle,
    isNotAvailable
  } = action;
  const styles = useStyles();
  const OptionIcon = getOptionIcon();
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.container, isNotAvailable && styles.notAvailable, className),
    onClick: !isNotAvailable ? onClick : null
  }, /*#__PURE__*/React.createElement(OptionIcon, {
    actionCode: code,
    className: styles.icon
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    className: styles.text
  }, name), isNotAvailable && /*#__PURE__*/React.createElement(Typography, {
    className: styles.notAvailableText
  }, unavailableOptionText), !isNotAvailable && subtitle && /*#__PURE__*/React.createElement(Typography, {
    className: styles.subtitle
  }, subtitle)));
};

export default OptionItem;